import { REPORT_INCIDENT_FAILED, REPORT_INCIDENT_SUCCESSFUL } from '../../features/SysGuard/sysGuardConstants';
import { UPDATE_ALERT_STATUS_SUCCEEDED,CLOSE_SNACKBAR,UPDATE_ALERT_STATUS_FAILED, SET_ALERT_DRAWER_PAGE_LOADER } from '../constants/constants';

const initialState = {
    alertUpdated : false,
    successMessage: '',
    unsuccessful : '',
    alertStatus:'',
    loader: false
  };

  export const changeAlertStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ALERT_STATUS_SUCCEEDED: {
            console.log("UPDATE_ALERT_STATUS_SUCCEEDED");
            return {
              ...state,
              successMessage: 'Alert(s) status Updated',
              alertUpdated: true,
              alertStatus:action.payload
            };
          }
          case UPDATE_ALERT_STATUS_FAILED: {
            console.log("UPDATE_ALERT_STATUS_FAILED");
            return {
              ...state,
              alertUpdated: false,
              unsuccessful: action.payload,
            };
          }
          case REPORT_INCIDENT_SUCCESSFUL: {
             return {
              ...state,
              successMessage: 'Reported Incident Successfully',
              alertUpdated: true,
            };
          }
          case REPORT_INCIDENT_FAILED: {
             return {
              ...state,
              unsuccessful: 'Failed to Report Incident',
              alertUpdated: false,
            };
          }
          case CLOSE_SNACKBAR: {
            console.log("CLOSE_SNACKBAR");
            return {
              ...state,
              successMessage: "",
              unsuccessful: "",
              alertUpdated: false,
            };
          }
          case SET_ALERT_DRAWER_PAGE_LOADER: {
            return {
              ...state,
              loader: action.payload,
            }
          }
          default:
            return state;
    }
  };
